var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"router-header flex flex-wrap items-center mb-6"},[_c('div',{staticClass:"content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light"},[_c('h2',{staticClass:"mb-1"},[_vm._v(_vm._s(_vm.title))])]),_c('vx-breadcrumb',{staticClass:"ml-4 md:block hidden",attrs:{"route":_vm.routes,"isRTL":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }